import React from "react";
import { kebabCase } from "lodash";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { FaPrint, FaShareAlt } from "react-icons/fa";

const StickyMenu = ({ sections, annualReport }) => {
  const hasMenu = hasStickyMenu(sections)
  if (!hasMenu) {
    return <></>;
  }
  return (
    <nav className={`sticky overflow-x-auto -top-[1px] inset-x-0 z-30 bg-gray-50 border-b border-b-gray-200 print:my-16 print:bg-transparent ${annualReport === "2024" ? "border-t border-t-gray-200" : ""}`}>
      <h2 className="hidden print:block">Table of Contents</h2>
      <ol className={`mx-12  2xl:container flex print:block items-stretch divide-x divide-gray-200 text-sm xl:text-base ${annualReport === "2024" ? "font-medium" : ""}`}>
        {sections?.map((section, i) => {
          return section?.includeInStickyMenu?.includeSection &&
            (section.includeInStickyMenu?.menuTitle || section.heading) ? (
            <li className=" flex-shrink-0">
              <AnchorLink
                to={`#${
                  section.fieldGroupName.includes(
                    "Customsections_Customsections_MainContent"
                  )
                    ? "content"
                    : section.heading
                    ? kebabCase(section.heading).replace(/[0-9]/g, '')
                    : kebabCase(section.includeInStickyMenu?.menuTitle).replace(/[0-9]/g, '')
                }`}
                className={`sticky-menu-list-item`}
              >
                {section.includeInStickyMenu?.menuTitle || section.heading}
              </AnchorLink>
            </li>
          ) : null;
        })}
        <li className="print:hidden flex items-stretch flex-shrink-0">
          <AnchorLink
            to={`#print`}
            className="sticky-menu-list-item"
          >
            <span className="sr-only">Print this Page</span>
            <FaPrint />
          </AnchorLink>
        </li>
        <li className="print:hidden flex items-stretch flex-shrink-0">
          <AnchorLink
            to={`#share`}
            className="sticky-menu-list-item"
          >
            <span className="sr-only">Share this Page</span>
            <FaShareAlt />
          </AnchorLink>
        </li>
      </ol>
    </nav>
  );
};

StickyMenu.defaultProps = {
  heading: ``,
};

export default StickyMenu;

export function hasStickyMenu (sections ){
  return sections?.some(section => section.includeInStickyMenu?.includeSection && (section.includeInStickyMenu?.menuTitle || section.heading))
}